__turbopack_context__.v({
  "active": "ArPhotoButton-module__ftAskW__active",
  "button": "ArPhotoButton-module__ftAskW__button",
  "label": "ArPhotoButton-module__ftAskW__label",
  "loading": "ArPhotoButton-module__ftAskW__loading",
  "locked": "ArPhotoButton-module__ftAskW__locked",
  "pulse": "ArPhotoButton-module__ftAskW__pulse",
  "wrapper": "ArPhotoButton-module__ftAskW__wrapper",
});
